import {
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
  getHeader,
} from "../utils/setting";

import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
const serviceFuntion = {
  state: {
    serviceFunctions: [],
    functions: [],
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: (dispatch) => ({
    async getFunctionForRole(payload = {}, rootState) {
      let _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/serviceFunctions/getFunctionForRole";

      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({
              functions: result.data.function,
              serviceFunctions: result.data.service_function,
            });
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => {
          return false;
        });
    },
    async updateFunction(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceFunctions/updateFunction";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({
          functions: Object.values(payload.data),
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then(async function (result) {
          // if(!result.code) this
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default serviceFuntion;
